module.exports = __webpack_public_path__ + "img/9-onebg.01389fbf.png";